import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconChevronDownSmall: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} ariaLabel="chevron-down-small" maskId="round-filled-radius-1-stroke-1.5-IconChevronDownSmall"><path fillRule="evenodd" clipRule="evenodd" d="M12 12.9394L15.4697 9.46975C15.7626 9.17685 16.2374 9.17685 16.5303 9.46975C16.8232 9.76264 16.8232 10.2375 16.5303 10.5304L12.8839 14.1769C12.3957 14.665 11.6043 14.665 11.1161 14.1769L7.46967 10.5304C7.17678 10.2375 7.17678 9.76264 7.46967 9.46975C7.76256 9.17685 8.23744 9.17685 8.53033 9.46975L12 12.9394Z" fill="currentColor"/></CentralIconBase>;
});

export default IconChevronDownSmall;
